import React from 'react'

import { DIALOGS } from '~/core/constants'

import ChatDialog from '~/components/recents/session-details/chat/dialog'
import ParticipantsDialog from '~/components/recents/session-details/participants/participants-dialog'
import PollsDialog from '~/components/recents/session-details/polls/dialog'
import TranscriptDialog from '~/components/recents/session-details/transcript/dialog'
import PersonalRoomDialogs from './room-settings/personal-room-dialogs'
import CalendarsDialog from './room-settings/calendar-list-dialog'
import ScreenshotsSlideshowDialog from '~/components/recents/session-details/screenshot-capture/slideshow'
import JoinCustomRoom from './dialogs/join-custom-room'
import SalesforceAdd from '~/components/recents/session-details/salesforce/add'
import SalesforceRemove from '~/components/recents/session-details/salesforce/remove'
import SummaryDialog from '~/components/recents/session-details/summary/dialog'
import ShareMeetingDialog from '~/components/recents/session-details/heading/dialog'
import ActionItemsDialog from '~/components/recents/session-details/action-items/dialog'

import SwitchMeetingDialog from './dialogs/switch-meeting'
import RecordingsSlideshow from './recents/session-details/recordings/slideshow'
import LinksDialog from './recents/session-details/links/dialog'
import ConfirmJoinDialog from './dialogs/confirm-join'

export default {
  [DIALOGS.ACTION_ITEMS]: <ActionItemsDialog />,
  [DIALOGS.CALENDARS_LIST]: <CalendarsDialog />,
  [DIALOGS.CHAT]: <ChatDialog />,
  [DIALOGS.CONFIRM_JOIN]: <ConfirmJoinDialog />,
  [DIALOGS.EDIT_PERSONAL_ROOM]: <PersonalRoomDialogs />,
  [DIALOGS.JOIN_CUSTOM_ROOM]: <JoinCustomRoom />,
  [DIALOGS.NONE]: null,
  [DIALOGS.POLLS]: <PollsDialog />,
  [DIALOGS.PARTICIPANTS]: <ParticipantsDialog />,
  [DIALOGS.RECORDING_SLIDESHOW]: <RecordingsSlideshow />,
  [DIALOGS.SALESFORCE_ADD]: <SalesforceAdd />,
  [DIALOGS.SALESFORCE_REMOVE]: <SalesforceRemove />,
  [DIALOGS.SCREENSHOTS_SLIDESHOW]: <ScreenshotsSlideshowDialog />,
  [DIALOGS.SHARE_MEETING]: <ShareMeetingDialog />,
  [DIALOGS.SHARED_MATERIALS]: <LinksDialog />,
  [DIALOGS.SUMMARY]: <SummaryDialog />,
  [DIALOGS.SWITCH_MEETING]: <SwitchMeetingDialog />,
  [DIALOGS.TRANSCRIPTIONS]: <TranscriptDialog />
}
